import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useResourcesUsers } from './useResourcesUsers';
import { useResourcesEquipment } from './useResourcesEquipment';

const useResources = () => {
  const calendarEvents = useSelector((state) => state.schedule.calendarEvents);
  const sheets = useSelector((state) => state.schedule.sheets);
  const showAllLocations = useSelector((state) => state.schedule.showAllLocations);

  const { userList } = useResourcesUsers();
  const { equipmentList } = useResourcesEquipment({
    unavailableResources: calendarEvents,
  });

  const userPermissions = useSelector((state) => state.personalProfile.fullUserPermissions);
  const canDragResources = useMemo(
    () => (
      !showAllLocations &&
      (userPermissions['scheduleEdit'] || userPermissions['scheduleFullAccess']
    )
  ), [userPermissions, showAllLocations]);

  return { userList, equipmentList, canDragResources };
};

export default useResources;